// First name for the greeting, from the SWA client principal.
//
// A custom Entra registration puts a `claims` array on /.auth/me (direct-access
// endpoint only - the API header does not carry it). Prefer the given name; else
// the first word of the full name; else, last resort, the part of the email
// before the @ ("GMyers@..." -> "GMyers"). Never a bare domain.

const GIVEN = new Set([
  'given_name',
  'givenname',
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname',
]);
const FULL = new Set(['name']);

function claimValue(claims, wanted) {
  if (!Array.isArray(claims)) return '';
  const hit = claims.find((c) => c && wanted.has(String(c.typ).toLowerCase()) && typeof c.val === 'string' && c.val.trim());
  return hit ? hit.val.trim() : '';
}

function firstNameOf(full) {
  if (!full || full.includes('@')) return '';
  // "Myers, Grant" -> "Grant"
  const afterComma = full.includes(',') ? full.split(',')[1].trim() : full;
  return afterComma.split(/\s+/)[0] || '';
}

export function displayNameFrom(principal) {
  const given = claimValue(principal?.claims, GIVEN);
  if (given && !given.includes('@')) return given;

  const fromFull = firstNameOf(claimValue(principal?.claims, FULL));
  if (fromFull) return fromFull;

  const email = principal?.userDetails;
  if (!email) return 'there';
  const local = String(email).split('@')[0];
  return local.replace(/[._]+/g, ' ').trim() || 'there';
}
